import { jsxs as l, Fragment as y, jsx as r } from "react/jsx-runtime";
import { useEffect as R } from "react";
import { useForm as T, Field as u } from "react-final-form";
import { useTranslation as k } from "react-i18next";
import L from "lodash/find";
import h from "lodash/get";
import I from "lodash/has";
import S from "lodash/isEmpty";
import f from "@mui/material/Box";
import B from "@mui/material/Checkbox";
import O from "@mui/material/Divider";
import U from "@mui/material/FormControlLabel";
import _ from "@mui/material/Grid";
import w from "@mui/material/TextField";
import c from "@mui/material/Typography";
import { makeStyles as M } from "tss-react/mui";
import { CardBase as V } from "../../../../common/Cards/CardBase/CardBase.js";
import { useBusRentalContext as $ } from "../../BusRental.context.js";
import { FIELD_NAME as n } from "../../constant/index.js";
import j from "./RouteInfoForm.style.js";
const A = M()(j), D = () => {
  const { classes: o } = A(), { t: a } = k(), i = T(), { routeList: d, selectedRoute: m } = $();
  R(() => {
    i.reset({
      ...i.getState().values,
      [n.ROUTE]: m ? [m] : []
    });
  }, [m]);
  const {
    values: g,
    submitFailed: x,
    errors: F
  } = i.getState(), p = h(g, "route"), E = !S(p), b = I(F, "route"), N = !!L(
    p,
    (e) => e === n.CUSTOM_ROUTE
  ), v = x && (!E || b);
  return /* @__PURE__ */ l(y, { children: [
    /* @__PURE__ */ r(c, { variant: "h6", className: o.groupLabel, children: a("route_information") }),
    /* @__PURE__ */ r(
      O,
      {
        sx: { marginTop: 2, marginBottom: 2 },
        className: o.divider
      }
    ),
    /* @__PURE__ */ l(f, { children: [
      /* @__PURE__ */ r(_, { container: !0, spacing: 2, children: d && d.map((e) => {
        const t = h(e, "id");
        return /* @__PURE__ */ r(_, { item: !0, xs: 6, sm: 4, children: /* @__PURE__ */ r(
          u,
          {
            name: n.ROUTE,
            type: "checkbox",
            value: e == null ? void 0 : e.code,
            children: ({ input: s }) => {
              const C = `${o.card} ${s.checked ? "selected" : ""}`;
              return /* @__PURE__ */ r(V, { className: C, children: /* @__PURE__ */ r(
                U,
                {
                  control: /* @__PURE__ */ r(
                    B,
                    {
                      checked: s.checked,
                      name: s.name,
                      onChange: s.onChange,
                      className: o.checkbox
                    }
                  ),
                  label: e == null ? void 0 : e.routeLabel
                }
              ) });
            }
          }
        ) }, t);
      }) }),
      v && /* @__PURE__ */ r(c, { className: o.routeErrorMsg, children: a("please_select_route") }),
      N && /* @__PURE__ */ l(f, { mt: { xs: 3 }, children: [
        /* @__PURE__ */ r(c, { variant: "h6", className: o.inputLabel, children: a("plan_information") }),
        /* @__PURE__ */ r(u, { name: n.PLAN_INFO, children: ({ input: e, meta: t }) => /* @__PURE__ */ r(
          w,
          {
            className: o.formField,
            variant: "outlined",
            multiline: !0,
            rows: 6,
            placeholder: a(
              "write_down_your_plan_to_help_us_serve_you_better"
            ),
            "data-testid": "planInformation",
            defaultValue: e.value,
            InputProps: {
              className: o.inputField,
              // ...input,
              // value: input.value,
              onBlur: (s) => e.onChange(s)
            },
            error: t.error && t.touched,
            helperText: t.error && t.touched && /* @__PURE__ */ r("span", { "data-testid": "contactUsEmailError", children: t.error })
          }
        ) })
      ] })
    ] })
  ] });
}, mr = D;
export {
  mr as default
};
